export default "__VITE_ASSET__BXK58lIM__"